import React from 'react';
import classNames from 'classnames';
import { useLocation, useMatch, Link } from 'react-router-dom';

const SwitcherItem = ({ exact, link, label }) => {
  const location = useLocation();
  const match = useMatch(link === '/' ? link : `${link}/*`);

  const active = exact ? location.pathname === link : !!match;

  return (
    <Link
      className={classNames('py-2 px-5 rounded-lg font-family', {
        'text-gray-03 shadow-md bg-white font-semibold': active,
        'text-gray-04 font-normal': !active,
      })}
      to={link}
    >
      {label}
    </Link>
  );
};

export default SwitcherItem;
